import { createAction, props } from '@ngrx/store';
import {
	BatchEntry,
	ChangeEntry,
	ChangeEntryListResource,
	ChangeEntryResource,
	ChangeEntryVermerk,
} from './register-change.model';
import { VerfahrenResource } from '@schir-int-client/verfahren-shared';

const PREFIX = '[Register Change] ';

export const refreshStateAction = createAction(PREFIX + 'Refresh State');

export const loadChangeEntriesAction = createAction(
	PREFIX + 'Load Change Entries',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadChangeEntriesSuccessAction = createAction(
	PREFIX + 'Load Change Entries Success',
	props<{
		changeEntries: ChangeEntryListResource;
	}>()
);

export const updateChangeEntryAction = createAction(
	PREFIX + 'Update Change Entry',
	props<{
		changeEntry: ChangeEntryResource;
	}>()
);

export const addChangeEntryAction = createAction(
	PREFIX + 'Add Change Entry',
	props<{
		changeEntry: ChangeEntry;
	}>()
);

export const addEntryBatchAction = createAction(
	PREFIX + 'Add Entry Batch',
	props<{
		batchEntries: BatchEntry[];
	}>()
);

// SCHIFF-5205 - neuer Vermerk deaktiviert
export const addVermerkEntryAction = createAction(
	PREFIX + 'Add Vermerk Entry',
	props<{
		changeEntryVermerk: ChangeEntryVermerk;
	}>()
);

export const deleteEntryAction = createAction(
	PREFIX + 'Delete Entry',
	props<{
		changeEntry: ChangeEntryResource;
	}>()
);

export const createUmschreibungEntryAction = createAction(
	PREFIX + 'Create Umschreibung Entry',
	props<{
		changeEntryResource: ChangeEntryResource;
		newChangeEntry: ChangeEntry;
	}>()
);
